var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgThermostatControlFlame = function SvgThermostatControlFlame(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2",
    width: 18,
    height: 18,
    viewBox: "0 0 12 12",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path3209",
    fill: "#d32f2f",
    fillRule: "evenodd",
    d: "M4.687 12c-2.093-.411-3.123-1.873-3.193-3.873S4.832 2.395 4.993 0c2.668 1.286 5.589 4.567 5.513 8.133-.075 3.565-3.33 3.863-3.33 3.863s1.719-1.43 1.62-3.688c-.1-2.257-2.287-4.086-2.287-4.086.113 2.877-.91 4.046-.91 4.046-.144-1.222-.886-1.728-.886-1.728-.627 1.8-2.148 3.193-.026 5.46z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgThermostatControlFlame);
export default ForwardRef;